import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useFetchPlaylistContent, useFetchPlaylistDetails, useFetchPlaylistsAccessData, useFetchPlaylistsShareData } from 'actions/playlists';
import useElementSize from 'hooks/useElementSize';
import { hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
import EmptyStateController from 'components/EmptyStateController';
import Stack from 'components/Stack';
import PlaylistManageContentScreen from 'screens/PlaylistManageContentScreen';
import SingleAccessPage from 'screens/PlaylistAccessPage';
import SinglePlaylistSharePage from 'screens/PlaylistSharePage';
import SingleAnalyticsPage from 'screens/PlaylistAnalyticsPage';
import { useGetSharingPermissions } from 'screens/ShareModal';
import { DEFAULT_EDIT_PLAYLIST_ROUTES } from './utils/defaultRoutes';
import { getIsActiveTab as getIsActiveTabDefault } from './utils/getIsActiveTab';
import { getTabLink as getTabLinkDefault } from './utils/getTabLink';
import { useGetTabInfo } from './utils/useGetTabInfo';
import { SinglePlaylistManagerHeader } from './Components/Header/Header';
import { EditPlaylistDetailsPage } from './EditPlaylistDetailsPage';
import PlaylistHeaderSubtitle from './Components/Header/PlaylistHeaderSubtitle';
import NextSteps, { getNextSteps } from './Components/NextStepsDetails';
import ErrorContent from 'components/ErrorContent';
function SinglePlaylistManager(_ref) {
  var providedPlaylistId = _ref.playlistId,
    playlist = _ref.playlist,
    _ref$inContentManager = _ref.inContentManagerContext,
    inContentManagerContext = _ref$inContentManager === void 0 ? false : _ref$inContentManager,
    _ref$includeDeletedPl = _ref.includeDeletedPlaylists,
    includeDeletedPlaylists = _ref$includeDeletedPl === void 0 ? false : _ref$includeDeletedPl,
    _ref$enableNextSteps = _ref.enableNextSteps,
    enableNextSteps = _ref$enableNextSteps === void 0 ? true : _ref$enableNextSteps,
    _ref$showHeaderBackLi = _ref.showHeaderBackLink,
    showHeaderBackLink = _ref$showHeaderBackLi === void 0 ? true : _ref$showHeaderBackLi,
    _ref$showAccessTab = _ref.showAccessTab,
    showAccessTab = _ref$showAccessTab === void 0 ? true : _ref$showAccessTab,
    _ref$showContentTab = _ref.showContentTab,
    showContentTab = _ref$showContentTab === void 0 ? true : _ref$showContentTab,
    _ref$showShareTab = _ref.showShareTab,
    showShareTab = _ref$showShareTab === void 0 ? true : _ref$showShareTab,
    _ref$stickyNavbarHeig = _ref.stickyNavbarHeight,
    stickyNavbarHeight = _ref$stickyNavbarHeig === void 0 ? 0 : _ref$stickyNavbarHeig,
    _ref$hasDeleteOrResto = _ref.hasDeleteOrRestoreOption,
    hasDeleteOrRestoreOption = _ref$hasDeleteOrResto === void 0 ? true : _ref$hasDeleteOrResto,
    _ref$hasDuplicateOpti = _ref.hasDuplicateOption,
    hasDuplicateOption = _ref$hasDuplicateOpti === void 0 ? true : _ref$hasDuplicateOpti,
    routes = _ref.routes,
    titleId = _ref.titleId,
    _ref$getIsActiveTab = _ref.getIsActiveTab,
    getIsActiveTab = _ref$getIsActiveTab === void 0 ? getIsActiveTabDefault : _ref$getIsActiveTab,
    _ref$getTabLink = _ref.getTabLink,
    getTabLink = _ref$getTabLink === void 0 ? getTabLinkDefault : _ref$getTabLink,
    renderCustomAssetPicker = _ref.renderCustomAssetPicker,
    onSubmitDetailChanges = _ref.onSubmitDetailChanges,
    onDeletePlaylistSuccess = _ref.onDeletePlaylistSuccess,
    onClose = _ref.onClose,
    includeSearchParams = _ref.includeSearchParams;
  var location = useLocation();
  var params = useParams();
  var playlistId = Number(providedPlaylistId) || Number(params.playlistId);
  var _useElementSize = useElementSize(),
    editorPageHeaderHeight = _useElementSize.height,
    elementRef = _useElementSize.elementRef;
  var isPlaylistAdmin = hasPrivilege(PLAYLIST_WRITE);
  var _useGetTabInfo = useGetTabInfo({
      getTabLink: getTabLink,
      getIsActiveTab: getIsActiveTab,
      routes: routes,
      location: location,
      playlistId: playlistId
    }),
    tabLinks = _useGetTabInfo.tabLinks,
    activeTab = _useGetTabInfo.activeTab;
  var _useFetchPlaylistDeta = useFetchPlaylistDetails({
      id: playlistId,
      useErrorBoundary: true,
      includeDeleted: includeDeletedPlaylists
    }),
    fetchedDetails = _useFetchPlaylistDeta.data,
    detailsLoading = _useFetchPlaylistDeta.isLoading,
    detailsError = _useFetchPlaylistDeta.isError,
    detailsErrorData = _useFetchPlaylistDeta.error;
  var details = _objectSpread(_objectSpread({}, fetchedDetails), playlist);
  var _useFetchPlaylistCont = useFetchPlaylistContent({
      id: playlistId,
      // Only enable this query when the /content subroute is active
      enabled: showContentTab && (tabLinks.content.isActive || tabLinks.contentPreview.isActive)
    }),
    content = _useFetchPlaylistCont.items,
    contentLoading = _useFetchPlaylistCont.isLoading,
    contentError = _useFetchPlaylistCont.isError,
    contentErrorData = _useFetchPlaylistCont.error;
  var _useFetchPlaylistsAcc = useFetchPlaylistsAccessData({
      playlistIds: [playlistId],
      enabled: isPlaylistAdmin && showAccessTab && tabLinks.access.isActive
    }),
    accessItems = _useFetchPlaylistsAcc.items,
    accessLoading = _useFetchPlaylistsAcc.isLoading,
    accessError = _useFetchPlaylistsAcc.isError,
    accessErrorData = _useFetchPlaylistsAcc.error;
  var _useFetchPlaylistsSha = useFetchPlaylistsShareData({
      playlistIds: [playlistId],
      enabled: isPlaylistAdmin && tabLinks.share.isActive
    }),
    shareItems = _useFetchPlaylistsSha.items;
  var _useGetSharingPermiss = useGetSharingPermissions({
      name: details === null || details === void 0 ? void 0 : details.name,
      contentIds: [playlistId],
      playlistsToShare: details ? [_objectSpread(_objectSpread({}, details), shareItems[0])] : undefined
    }),
    shareData = _useGetSharingPermiss.shareData;
  var _getNextSteps = getNextSteps({
      playlist: details,
      enableNextSteps: enableNextSteps
    }),
    showNextSteps = _getNextSteps.showNextSteps,
    hasAudience = _getNextSteps.hasAudience,
    hasContent = _getNextSteps.hasContent,
    hasCompleteMetadata = _getNextSteps.hasCompleteMetadata,
    metadata = _getNextSteps.metadata;
  var errorMessage = (detailsErrorData === null || detailsErrorData === void 0 ? void 0 : detailsErrorData.message) || (contentErrorData === null || contentErrorData === void 0 ? void 0 : contentErrorData.message) || (accessErrorData === null || accessErrorData === void 0 ? void 0 : accessErrorData.message);
  var isLoading = detailsLoading || contentLoading || accessLoading;
  var isError = detailsError || contentError || accessError;
  var stickyHeaderCompensation = stickyNavbarHeight + (editorPageHeaderHeight !== null && editorPageHeaderHeight !== void 0 ? editorPageHeaderHeight : 0);
  var renderActiveTab = function renderActiveTab() {
    switch (activeTab) {
      case 'details':
        return !!details && !isLoading && /*#__PURE__*/React.createElement(EditPlaylistDetailsPage, {
          initialPlaylistDetails: details,
          inContentManagerContext: inContentManagerContext,
          onSubmit: onSubmitDetailChanges
        });
      case 'content':
      case 'contentPreview':
        return showContentTab && !!details && !isLoading && /*#__PURE__*/React.createElement(PlaylistManageContentScreen, {
          key: playlistId,
          stickyHeaderCompensation: stickyHeaderCompensation,
          initialPlaylistData: _objectSpread(_objectSpread({}, details), {}, {
            content: content
          }),
          routes: {
            root: tabLinks.content.link,
            preview: tabLinks.contentPreview.link
          },
          renderCustomAssetPicker: renderCustomAssetPicker
        });
      case 'analytics':
        return details && !isLoading && /*#__PURE__*/React.createElement(SingleAnalyticsPage, {
          playlistId: playlistId,
          name: details.name
        });
      case 'access':
        return showAccessTab && accessItems.length > 0 && !isLoading && /*#__PURE__*/React.createElement(SingleAccessPage, {
          playlistId: playlistId,
          accessData: accessItems[0]
        });
      case 'share':
        return showShareTab && shareItems.length > 0 && !isLoading && /*#__PURE__*/React.createElement(SinglePlaylistSharePage, {
          playlistId: playlistId,
          autoShareData: shareItems[0],
          shareData: shareData
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isError && /*#__PURE__*/React.createElement(SinglePlaylistManagerHeader, {
    elementRef: elementRef,
    stickyNavbarHeight: stickyNavbarHeight,
    titleId: titleId,
    playlistId: playlistId,
    showHeaderBackLink: showHeaderBackLink,
    showAccessTab: showAccessTab,
    showContentTab: showContentTab,
    showShareTab: showShareTab,
    includeDeletedPlaylists: includeDeletedPlaylists,
    shareData: shareData,
    tabLinks: tabLinks,
    hasDeleteOrRestoreOption: hasDeleteOrRestoreOption,
    hasDuplicateOption: hasDuplicateOption,
    onDeletePlaylistSuccess: onDeletePlaylistSuccess,
    onClose: onClose,
    includeSearchParams: includeSearchParams
  }), /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, !isLoading && !isError && showNextSteps && /*#__PURE__*/React.createElement(NextSteps, {
    id: playlistId,
    hasContent: hasContent,
    hasAudience: hasAudience,
    hasCompleteMetadata: hasCompleteMetadata,
    metadata: metadata
  }), /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: isLoading,
    isError: isError,
    height: 600,
    errorContent: /*#__PURE__*/React.createElement(ErrorContent, {
      errorMessage: errorMessage
    })
  }, renderActiveTab())));
}
export { DEFAULT_EDIT_PLAYLIST_ROUTES };
export { ExternalDomainLink } from './Components/ExternalDomainLink';
export { PlaylistHeaderSubtitle };
export * from './Components/Header/HeaderOptionsMenu';
export { getDistributedInfo } from './utils/getDistributedInfo';
export default SinglePlaylistManager;